import { EditUserFormValues } from '../../../types/userform';
import { USER_FORM_FIELDS_KEY } from '../../model/types';

export const editUserDefaultValues: EditUserFormValues = {
    [USER_FORM_FIELDS_KEY]: null,
    fullName: null,
    groups: null,
    organization: null,
    primaryEmail: null,
    primaryPhone: null,
    role: null,
    roleToChange: null,
    secondaryEmails: [],
    secondaryPhones: [],
    userId: null
};
